import { default as _91_46_46_46page_93w05VuUBg88Meta } from "/app/solution/pages/[...page].vue?macro=true";
export default [
  {
    name: "page",
    path: "/:page(.*)*",
    meta: _91_46_46_46page_93w05VuUBg88Meta || {},
    component: () => import("/app/solution/pages/[...page].vue").then(m => m.default || m)
  }
]